export default "__VITE_ASSET__7JZMdsJK__"